import { GroupSettings } from 'admin/services/group-settings';

export type AdminGroupSettingsNamespaceState = {
  initialized: false,
  groups: string[]
}

export enum Actions {
  Init = 'admin-group-settings/Init',
  Example = 'admin-group-settings/Example',

}

export interface ExampleAction {
  type: Actions.Example,
  payload: GroupSettings,
}
export interface InitAction {
  type: Actions.Init,
}

export type AdminGroupActions =
  | InitAction
  | ExampleAction
